import { render, staticRenderFns } from "./OnlineRegistration.vue?vue&type=template&id=b0d4d39a&"
import script from "./OnlineRegistration.vue?vue&type=script&lang=js&"
export * from "./OnlineRegistration.vue?vue&type=script&lang=js&"
import style0 from "./OnlineRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports